import React, { useContext } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Navigation = () => {
    const { token, logout, userRole } = useContext(AuthContext);

    return (
        <Navbar bg="light" expand="lg">
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <img
                        src="/logo.png" // Chemin relatif à la racine du dossier public
                        height="50" // Ajustez la taille selon vos besoins
                        className="d-inline-block align-top"
                        alt="CoursDocs Logo"
                    />
                    {' '}
                    CoursDocs
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/">Liste des Modules</Nav.Link>
                        <Nav.Link as={Link} to="/transfer">Transférer des documents</Nav.Link>
                    </Nav>
                    <Nav>
                        {token ? (
                            <>
                                {userRole === 'admin' && (
                                    <Nav.Link as={Link} to="/admin/register">Add User</Nav.Link>
                                )}
                                <Button variant="outline-danger" onClick={logout}>Logout</Button>
                            </>
                        ) : (
                            <>
                                <Nav.Link as={Link} to="/login">Login</Nav.Link>
                            </>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navigation;
